function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconManufacturer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Group 1496",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/Manufacturers"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 232",
    style: {
      fill: "none"
    },
    d: "M0 0h28v28H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1221",
    d: "M16345.806 13195.665h-5.443a1.356 1.356 0 0 1-1.363-1.345v-2.837a1.357 1.357 0 0 1 .8-1.229l.748-12.1h-.189a.577.577 0 1 1 0-1.153h3.5a.577.577 0 1 1 0 1.153h-.189l.67 11.094.881-.189v-3.57a.576.576 0 0 1 .215-.447.589.589 0 0 1 .371-.127.54.54 0 0 1 .117.011l11.275 2.3a.583.583 0 0 1 .465.565v6.53a1.355 1.355 0 0 1-1.361 1.345zm7.971-3.266v.385a.583.583 0 0 0 .586.577h.387a.582.582 0 0 0 .584-.577v-.385a.581.581 0 0 0-.584-.576h-.387a.583.583 0 0 0-.587.577zm-3.111 0v.385a.582.582 0 0 0 .582.577h.393a.581.581 0 0 0 .582-.577v-.385a.581.581 0 0 0-.582-.576h-.393a.582.582 0 0 0-.583.577zm-3.111 0v.385a.58.58 0 0 0 .582.577h.391a.58.58 0 0 0 .584-.577v-.385a.58.58 0 0 0-.584-.576h-.391a.58.58 0 0 0-.583.577zm-6.414.385a.577.577 0 0 0 .582.574h1.555a.575.575 0 1 0 0-1.15h-1.555a.579.579 0 0 0-.583.576zm12.637-3.456v.383a.582.582 0 0 0 .586.576h.387a.58.58 0 0 0 .584-.576v-.383a.582.582 0 0 0-.584-.579h-.387a.584.584 0 0 0-.588.579zm-3.111 0v.383a.581.581 0 0 0 .582.576h.393a.58.58 0 0 0 .582-.576v-.383a.582.582 0 0 0-.582-.579h-.393a.583.583 0 0 0-.584.579zm-3.111 0v.383a.579.579 0 0 0 .582.576h.391a.579.579 0 0 0 .584-.576v-.383a.581.581 0 0 0-.584-.579h-.391a.58.58 0 0 0-.584.579z",
    transform: "translate(-16334.332 -13172.332)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconManufacturer);
export default __webpack_public_path__ + "static/media/iconManufacturer.09bdb870.svg";
export { ForwardRef as ReactComponent };